import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useElectronIPCPairerPresenter } from './ElectronIPCPairer.presenter';

export const ElectronIPCPairer: FC = observer(() => {
  useElectronIPCPairerPresenter();

  return null;
});
